var _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_180_1",
    "data-name": "Componente 180 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5768",
    "data-name": "Grupo 5768",
    transform: "translate(6 6.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170804",
    "data-name": "Grupo 170804"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_205",
    "data-name": "Elipse 205",
    cx: 26,
    cy: 26,
    rx: 26,
    ry: 26,
    transform: "translate(0 -0.264)",
    fill: "#ff0f0b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170803",
    "data-name": "Grupo 170803",
    transform: "translate(-0.146 -1.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5767",
    "data-name": "Grupo 5767",
    transform: "translate(10.146 14.901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5765",
    "data-name": "Grupo 5765"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_207",
    "data-name": "Elipse 207",
    cx: 2.582,
    cy: 3.127,
    rx: 2.582,
    ry: 3.127,
    transform: "translate(3.238 7.186)",
    fill: "#8d0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_213",
    "data-name": "Trazado 213",
    d: "M362.3,603.022a18.536,18.536,0,0,1-2.2-.6,19.956,19.956,0,0,1-2.094-.84,12.482,12.482,0,0,1-3.751-2.622.73.73,0,0,1,1.025-1.038l.016.015a10.939,10.939,0,0,0,3.4,2.069,18.256,18.256,0,0,0,1.941.644,16.853,16.853,0,0,0,1.973.415l.027,0a.991.991,0,0,1-.275,1.963Z",
    transform: "translate(-354.053 -597.727)",
    fill: "#8d0000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5766",
    "data-name": "Grupo 5766",
    transform: "translate(22.186)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_208",
    "data-name": "Elipse 208",
    cx: 2.582,
    cy: 3.127,
    rx: 2.582,
    ry: 3.127,
    transform: "translate(1.035 7.186)",
    fill: "#8d0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_214",
    "data-name": "Trazado 214",
    d: "M536.791,601.065a16.856,16.856,0,0,0,1.973-.415,18.245,18.245,0,0,0,1.941-.644,10.936,10.936,0,0,0,3.4-2.069l.015-.013a.73.73,0,0,1,1.027,1.036,12.483,12.483,0,0,1-3.751,2.622,19.956,19.956,0,0,1-2.094.84,18.529,18.529,0,0,1-2.2.6.991.991,0,0,1-.395-1.943l.057-.01Z",
    transform: "translate(-535.909 -597.727)",
    fill: "#8d0000"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_215",
    "data-name": "Trazado 215",
    d: "M426.468,738.894c-4.053,0-7.4,2.662-7.939,6.117a.6.6,0,0,0,.772.667,20.322,20.322,0,0,1,14.334,0,.6.6,0,0,0,.772-.667C433.873,741.556,430.522,738.894,426.468,738.894Z",
    transform: "translate(-400.51 -706.771)",
    fill: "#8d0000"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_148766",
    "data-name": "Rect\\xE1ngulo 148766",
    width: 64,
    height: 64,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.21de8167f3c534ee192425dde3ab6317.svg";
export { ForwardRef as ReactComponent };